import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {Fetch} from '../../../envisia/workflow/models/fetch.models';
import {queryKeys} from '../../../../queryKeys';

interface Props {
  workflowId: number;
  fetchId: number;
  successCallback: () => void;
}

export function useFetchPriceConfirmMutation({workflowId, fetchId, successCallback}: Props) {
  const queryClient = useQueryClient();
  const {mutate, isPending} = useMutation({
    mutationFn: () =>
      AxiosHttpClient.putNullable<Fetch>(
        `${environment.apiv4uri}workflow/${workflowId}/fetch/${fetchId}/price/confirm`,
        {},
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: queryKeys.fetch.priceValidation(workflowId, fetchId)});
      successCallback();
    },
  });

  return {
    mutateFetchPriceConfirmIsPending: isPending,
    mutateFetchPriceConfirm: () => mutate(),
  };
}
